import React from "react";
import ReactECharts from "echarts-for-react";

const IndusBenchMark1 = () => {
  const option = {
    title: {
      text: "Industry Benchmarking",
      left: "center",
      textStyle: {
        color: "#333",
        fontSize: 18,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      bottom: 0,
      textStyle: {
        color: "#333",
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      axisLabel: {
        color: "#333",
      },
      max: 100,
      splitLine: {
        show: true,
        lineStyle: {
          color: "#ccc",
          type: "dashed",
        },
      },
    },
    yAxis: {
      type: "category",
      data: ["Your Business Cost Structure", "Industry Cost Structure"],
      axisLabel: {
        color: "#333",
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#ccc",
          type: "dashed",
        },
      },
    },
    series: [
      {
        name: "Wages",
        type: "bar",
        stack: "total",
        data: [10, 15],
        color: "#4CAF50",
      },
      {
        name: "Purchases/COGS",
        type: "bar",
        stack: "total",
        data: [78, 77],
        color: "#1976D2",
      },
      {
        name: "Rent",
        type: "bar",
        stack: "total",
        data: [1, 2],
        color: "#D32F2F",
      },
      {
        name: "Utilities",
        type: "bar",
        stack: "total",
        data: [0, 1],
        color: "#9C27B0",
      },
      {
        name: "Depreciation",
        type: "bar",
        stack: "total",
        data: [0, 80],
        color: "#FFC107",
      },
      {
        name: "Other",
        type: "bar",
        stack: "total",
        data: [4, 1],
        color: "#FF5722",
      },
      {
        name: "Profit",
        type: "bar",
        stack: "total",
        data: [7, 30],
        color: "#2E7D32",
      },
    ],
    backgroundColor: "#fff",
  };

  return <ReactECharts option={option} style={{ height: "400px", width: "100%" }} />;
};

export default IndusBenchMark1;
